import { connect } from 'react-redux';

import { getActiveScriptId, getDuplicateModal } from 'current/selectors';
import {
  closeDuplicateModal,
  validateNewDuplicateInputValue
} from 'current/uiwidgets/';
import { duplicateScript } from 'scripts';
import { getDuplicateScriptValidationResult } from 'validations/selectors';

import DuplicateModal from './DuplicateModal';

export default connect(
  (state) => {
    return {
      duplicateModal: getDuplicateModal(state),
      scriptId: getActiveScriptId(state),
      validationResult: getDuplicateScriptValidationResult(state)
    };
  },
  (dispatch) => {
    return {
      onCancelDuplicateModal: () => {
        dispatch(closeDuplicateModal());
      },
      onChangeDuplicateInput: (newValue) => {
        dispatch(validateNewDuplicateInputValue(newValue));
      },
      onSaveDuplicateModal: ({ scriptId }) => {
        dispatch(duplicateScript({ scriptId }));
      }
    };
  }
)(DuplicateModal);
